module.exports = __webpack_public_path__ + "static/media/IMG_4481.e1fe03b2.jpg";